import { Component } from './Component';
import { Header } from './Header';
import { Router } from '../router/Router';
import { StepBar } from './StepBar';

/**
 * Component for handling technical error.
 */
export class TechnicalError extends Component {
  /**
   * String of the dom element of the finish button.
   *
   * @type {string}
   */
  static btnFinishDOMSelector = '#btnTechnicalError';

  /**
   * Render template.
   *
   * @param {object} opts - The options to render in the component.
   */
  render(opts) {
    Component.updateTracking({ type_page: 'erreur_technique' });

    super.render(opts);
    Header.deleteBackButton();
    StepBar.deleteStepBar();
    this.attachSubmitEvent();

    const technicalErrorTitle = document.querySelector('#eui-technicalError .feedback-title');

    if (technicalErrorTitle !== null) {
      technicalErrorTitle.focus();
    }
  }

  /**
   * Attach submit event.
   */
  attachSubmitEvent() {
    document.querySelector(TechnicalError.btnFinishDOMSelector).addEventListener('click', () => {
      Router.closeApp({
        redirectUrl: 'https://r.orange.fr/r/Oid_accueil',
      });
    });
  }
}
